import { render, staticRenderFns } from "./CarouselType.vue?vue&type=template&id=564cd4c4&scoped=true"
import script from "./CarouselType.vue?vue&type=script&lang=ts"
export * from "./CarouselType.vue?vue&type=script&lang=ts"
import style0 from "./CarouselType.vue?vue&type=style&index=0&id=564cd4c4&prod&scoped=true&lang=scss"
import style1 from "./CarouselType.vue?vue&type=style&index=1&id=564cd4c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564cd4c4",
  null
  
)

export default component.exports